import store from '@/store/tutorial_editor'
export default {
    store
}